export default __webpack_public_path__ + "static/dot-map-top-3c485b9f26b1ee197bf2b4e8870d8c3e.svg";